import styled from "styled-components";

import HomeQuizBox from "./QuizBox";
import { DarkGrey } from "./colors";
import { getIcon } from "../../services/iconMap";

export const ScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  padding: 20px 10vw;
  gap: 20px;
  -webkit-overflow-scrolling: touch;

  /* ✅ Hide scrollbar on WebKit (Chrome, Safari) */
  &::-webkit-scrollbar {
    display: none;
  }

  /* ✅ Hide scrollbar on Firefox */
  scrollbar-width: none;
`;

export const StyledQuizBox = styled(HomeQuizBox)`
  flex: 0 0 80vw;
  max-width: 350px;
  scroll-snap-align: center;
  background: ${DarkGrey};
`;

/**
 * Convert remote quiz display data to the format expected by the home page
 * @param {Array} remoteQuizzes - Array of remote quiz display objects from RemoteQuizService
 * @returns {Array} - Array of quizzes with icon components
 */
export const convertRemoteQuizzesToDisplay = (remoteQuizzes) => {
  return remoteQuizzes.map((quiz) => {
    // Get the icon component from the icon name
    const IconComponent = getIcon(quiz.iconName);

    return {
      id: quiz.id,
      title: quiz.title,
      description: quiz.description,
      icon: <IconComponent />,
      background: quiz.background,
      transitionBackground: quiz.transitionBackground,
      startURL: quiz.startURL,
      displayOrder: quiz.displayOrder,
      category: quiz.category || null,
      subcategory: quiz.subcategory || null,
    };
  });
};

/**
 * Convert remote quiz data to display format
 * @param {Array} remoteQuizzes - Array of remote quiz display objects
 * @returns {Array} - Array of quizzes ready for display
 */
export const mergeQuizData = (remoteQuizzes) => {
  if (!remoteQuizzes || remoteQuizzes.length === 0) {
    return [];
  }

  const converted = convertRemoteQuizzesToDisplay(remoteQuizzes);

  // Sort by displayOrder
  converted.sort((a, b) => (a.displayOrder || 999) - (b.displayOrder || 999));

  return converted;
};
